import Vue from "vue";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import moment from "moment";

// action types
export const GET_ZERA_FLUXOS_DE_CAIXA = "getZeraFluxosDeCaixa";
export const GET_FLUXOS_DE_CAIXA = "getFluxosDeCaixa";
export const GET_FLUXO_DE_CAIXA = "getFluxoDeCaixa";
export const GET_FLUXOS_DE_CAIXA_6_MESES = "getFluxosDeCaixa6Meses";
export const GET_EMITENTE_TELEFONE = "getEmitenteTelefone";
export const GET_EMITENTE_EMAILS = "getEmitenteEmails";
export const GET_ENVIAR_EMAIL_FLUXO = "getEnviarEmailFluxo";
export const GET_ENVIAR_SMS_FLUXO = "getEnviarSMSFluxo";
export const GET_MULTA = "getMulta";
export const GET_GED = "getGED";
export const GET_GED_FILE = "getGEDFile";
export const GET_EXC_GED_FILE = "getExcGEDFile";
export const GET_RATEIOS = "getRateios";
export const UPDATE_RATEIOS = "updateRateios";
export const UPDATE_FLUXO_DE_CAIXA = "updateFluxoDeCaixa";
export const SELECT_FLUXO_DE_CAIXA = "selectFluxoDeCaixa";
export const MENU_FLUXO_DE_CAIXA = "menuFluxoDeCaixa";
export const UPDATE_FLUXO_DE_CAIXA_BUSCA = "updateFluxoDeCaixaBusca";
export const GET_BOLETOS_FLUXO = "getBoletosFluxo";
export const GET_NFS_FLUXO = "getNFsFluxo";
export const UPDATE_FLUXO_DE_CAIXA_PAGAMENTO = "updateFluxoDeCaixaPagamento";
export const GET_RELATORIOS_RECEBIMENTOS = "getRelatoriosRecebimentos";
export const GET_RELATORIOS_TRANSFERENCIAS = "getRelatoriosTransferencias";

// mutation types
export const SET_FLUXOS_DE_CAIXA = "setFluxosDeCaixa";
export const SET_MENU_FLUXOS_DE_CAIXA = "setMenuFluxosDeCaixa";
export const SET_SELECT_FLUXOS_DE_CAIXA = "setSelectFluxoDeCaixa";
export const SET_FILTROS_FLUXOS_DE_CAIXA = "setFiltrosFluxosDeCaixa";
export const SET_SUM_FLUXOS_DE_CAIXA = "setSumFluxosDeCaixa";
export const SET_TOTAL_FLUXOS_DE_CAIXA = "setTotalFluxosDeCaixa";
export const SET_FLUXO_DE_CAIXA_BUSCA = "setFluxoDeCaixaBusca";
export const SET_FLUXOS_DE_CAIXA_TOTAL_PROJETOS =
    "setFluxosDeCaixaTotalProjetos";
export const SET_FLUXOS_DE_CAIXA_TOTAL_PLANOS_FINANCEIROS =
    "setFluxosDeCaixaTotalPlanosFinanceiros";
export const SET_FLUXOS_DE_CAIXA_TOTAL_CENTROS_DE_RESPONSABILIDADE =
    "setFluxosDeCaixaTotalCentrosDeResponsabilidade";
export const SET_FLUXOS_DE_CAIXA_TOTAL_PORTADORES =
    "setFluxosDeCaixaTotalPortadores";
export const SET_EMITENTES_PF_FLUXOS_DE_CAIXA = "setEmitentesPFFluxosDeCaixa";
export const SET_EMITENTES_PJ_FLUXOS_DE_CAIXA = "setEmitentesPJFluxosDeCaixa";
export const SET_VALOR_FLUXOS_DE_CAIXA = "setValorFluxosDeCaixa";

const state = {
    fluxosDeCaixa: [],
    fluxosDeCaixaQuantidadeTotal: 0,
    fluxosDeCaixaQuantidadeEmitentesPF: 0,
    fluxosDeCaixaQuantidadeEmitentesPJ: 0,
    fluxosDeCaixaQuantidadeValor: 0,
    fluxosDeCaixaValoresTotaisProjetos: [],
    fluxosDeCaixaValoresTotaisPlanosFinanceiros: [],
    fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade: [],
    fluxosDeCaixaValoresTotaisPortadores: [],
    fluxosDeCaixaUltimoFiltro: {
        inicio: "",
        fim: "",
        empresa: "",
        projeto: "",
        planoFinanceiro: "",
        centroDeResponsabilidade: "",
        portador: "",
        tipo: "",
        fluxoDeCaixaBusca: "",
        filtroAbas: "",
        dataFiltroTipo: ""
    },
    fluxoDeCaixaBusca: window.localStorage.getItem("validadeFiltroBuscaFluxo") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("buscaFluxo") ?
        window.localStorage.getItem("buscaFluxo") : "",
    fluxosDeCaixa6Meses: {},
    fluxoInclusaoAlteracaoBackup: {}
};

const getters = {
    fluxosDeCaixa(state) {
        return state.fluxosDeCaixa;
    },
    fluxosDeCaixaQuantidadeTotal(state) {
        return state.fluxosDeCaixaQuantidadeTotal;
    },
    fluxosDeCaixaQuantidadeEmitentesPF(state) {
        return state.fluxosDeCaixaQuantidadeEmitentesPF;
    },
    fluxosDeCaixaQuantidadeEmitentesPJ(state) {
        return state.fluxosDeCaixaQuantidadeEmitentesPJ;
    },
    fluxosDeCaixaQuantidadeValor(state) {
        return state.fluxosDeCaixaQuantidadeValor;
    },
    fluxosDeCaixaUltimoFiltro(state) {
        return state.fluxosDeCaixaUltimoFiltro;
    },
    fluxosDeCaixa6Meses(state) {
        return state.fluxosDeCaixa6Meses;
    },
    fluxoDeCaixaBusca(state) {
        return state.fluxoDeCaixaBusca;
    },
    fluxosDeCaixaValoresTotaisProjetos(state) {
        return state.fluxosDeCaixaValoresTotaisProjetos;
    },
    fluxosDeCaixaValoresTotaisPlanosFinanceiros(state) {
        return state.fluxosDeCaixaValoresTotaisPlanosFinanceiros;
    },
    fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade(state) {
        return state.fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade;
    },
    fluxosDeCaixaValoresTotaisPortadores(state) {
        return state.fluxosDeCaixaValoresTotaisPortadores;
    },
    fluxoInclusaoAlteracaoBackup(state) {
        return state.fluxoInclusaoAlteracaoBackup;
    }
};

const actions = {
    [GET_ZERA_FLUXOS_DE_CAIXA](context, datas) {
        context.commit(SET_FLUXOS_DE_CAIXA, []);
        context.commit(SET_FILTROS_FLUXOS_DE_CAIXA, datas);
        context.commit(SET_TOTAL_FLUXOS_DE_CAIXA, 0);
        context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PROJETOS, []);
        context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PLANOS_FINANCEIROS, []);
        context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_CENTROS_DE_RESPONSABILIDADE, []);
        context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PORTADORES, []);
        context.commit(SET_EMITENTES_PF_FLUXOS_DE_CAIXA, 0);
        context.commit(SET_EMITENTES_PJ_FLUXOS_DE_CAIXA, 0);
        context.commit(SET_VALOR_FLUXOS_DE_CAIXA, 0);
    },
    [GET_FLUXOS_DE_CAIXA](context, datas) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();

                if (
                    datas.inicio !== state.fluxosDeCaixaUltimoFiltro.inicio ||
                    datas.fim !== state.fluxosDeCaixaUltimoFiltro.fim ||
                    datas.empresa !== state.fluxosDeCaixaUltimoFiltro.empresa ||
                    datas.projeto !== state.fluxosDeCaixaUltimoFiltro.projeto ||
                    datas.planoFinanceiro !== state.fluxosDeCaixaUltimoFiltro.planoFinanceiro ||
                    datas.centroDeResponsabilidade !== state.fluxosDeCaixaUltimoFiltro.centroDeResponsabilidade ||
                    datas.portador !== state.fluxosDeCaixaUltimoFiltro.portador ||
                    datas.tipo !== state.fluxosDeCaixaUltimoFiltro.tipo ||
                    datas.fluxoDeCaixaBusca !== state.fluxosDeCaixaUltimoFiltro.fluxoDeCaixaBusca ||
                    datas.filtroAbas !== state.fluxosDeCaixaUltimoFiltro.filtroAbas ||
                    datas.dataFiltroTipo !== state.fluxosDeCaixaUltimoFiltro.dataFiltroTipo ||
                    datas.emitente !== state.fluxosDeCaixaUltimoFiltro.emitente ||
                    datas.ordenacaoFiltroTipo !== state.fluxosDeCaixaUltimoFiltro.ordenacaoFiltroTipo
                ) {
                    context.commit(SET_FLUXOS_DE_CAIXA, []);
                    context.commit(SET_FILTROS_FLUXOS_DE_CAIXA, datas);
                    context.commit(SET_TOTAL_FLUXOS_DE_CAIXA, 0);
                    context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PROJETOS, []);
                    context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PLANOS_FINANCEIROS, []);
                    context.commit(
                        SET_FLUXOS_DE_CAIXA_TOTAL_CENTROS_DE_RESPONSABILIDADE, []
                    );
                    context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PORTADORES, []);
                    context.commit(SET_EMITENTES_PF_FLUXOS_DE_CAIXA, 0);
                    context.commit(SET_EMITENTES_PJ_FLUXOS_DE_CAIXA, 0);
                    context.commit(SET_VALOR_FLUXOS_DE_CAIXA, 0);
                }

                ApiService.get(
                    "fluxosDeCaixa/" +
                    datas.inicio +
                    "/" +
                    datas.fim +
                    "/" +
                    datas.empresa +
                    "/" +
                    datas.projeto +
                    "/" +
                    datas.planoFinanceiro +
                    "/" +
                    datas.centroDeResponsabilidade +
                    "/" +
                    datas.portador +
                    "/" +
                    datas.tipo +
                    "/" +
                    state.fluxosDeCaixa.length +
                    "/" +
                    (datas.fluxoDeCaixaBusca ? btoa(datas.fluxoDeCaixaBusca) : "0") +
                    "/" +
                    datas.filtroAbas +
                    "/" +
                    datas.dataFiltroTipo +
                    "/" +
                    (datas.emitente ? datas.emitente : '0') +
                    "/" +
                    datas.ordenacaoFiltroTipo
                ).then(({ data }) => {
                    context.commit(SET_SUM_FLUXOS_DE_CAIXA, data.fluxos);
                    context.commit(SET_TOTAL_FLUXOS_DE_CAIXA, data.quantidadeTotal);
                    context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PROJETOS, data.projetos);
                    context.commit(
                        SET_FLUXOS_DE_CAIXA_TOTAL_PLANOS_FINANCEIROS,
                        data.planosFinanceiros
                    );
                    context.commit(
                        SET_FLUXOS_DE_CAIXA_TOTAL_CENTROS_DE_RESPONSABILIDADE,
                        data.centrosDeResponsabilidade
                    );
                    context.commit(SET_FLUXOS_DE_CAIXA_TOTAL_PORTADORES, data.portadores);
                    context.commit(
                        SET_EMITENTES_PF_FLUXOS_DE_CAIXA,
                        data.quantidadeEmitentesPF
                    );
                    context.commit(
                        SET_EMITENTES_PJ_FLUXOS_DE_CAIXA,
                        data.quantidadeEmitentesPJ
                    );
                    context.commit(SET_VALOR_FLUXOS_DE_CAIXA, data.valor);
                    resolve(data);
                });
            }
        });
    },
    [GET_FLUXO_DE_CAIXA](context, idFluxoDeCaixa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("fluxoDeCaixa/" + idFluxoDeCaixa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_FLUXOS_DE_CAIXA_6_MESES](context, data) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get(
                    "fluxosDeCaixa6Meses/" +
                    data.tipo +
                    "/" +
                    data.empresa +
                    "/" +
                    data.projeto +
                    "/" +
                    data.planoFinanceiro +
                    "/" +
                    data.centroDeResponsabilidade +
                    "/" +
                    data.portador
                ).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_EMITENTE_TELEFONE](context, info) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("emitenteTelefones/" + info).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_EMITENTE_EMAILS](context, info) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("emitenteEmails/" + info).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_ENVIAR_EMAIL_FLUXO](context, info) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("enviarEmailCobranca/" + info.idFluxoCaixa, {
                    emails: info.emails
                }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_ENVIAR_SMS_FLUXO](context, info) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("enviarSMSCobranca/" + info).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_MULTA](context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("multa/" + id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_RATEIOS](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("rateios/" + dados.idFluxoDeCaixa, dados.items).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_FLUXO_DE_CAIXA](context, fluxoDeCaixa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa", fluxoDeCaixa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [SELECT_FLUXO_DE_CAIXA](context, fluxoDeCaixa) {
        context.commit(SET_SELECT_FLUXOS_DE_CAIXA, fluxoDeCaixa);
    },
    [MENU_FLUXO_DE_CAIXA](context, menu) {
        context.commit(SET_MENU_FLUXOS_DE_CAIXA, menu);
    },
    [UPDATE_FLUXO_DE_CAIXA_BUSCA](context, fluxoDeCaixaBusca) {
        context.commit(SET_FLUXO_DE_CAIXA_BUSCA, fluxoDeCaixaBusca);
    },
    [GET_GED](context, idFluxoDeCaixa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("listarGED/" + idFluxoDeCaixa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_GED_FILE](context, token) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.getFile("visualizarGED/" + token).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_EXC_GED_FILE](context, token) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.getFile("excluirGED/" + token).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_RATEIOS](context, idFluxoDeCaixa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("listarRateios/" + idFluxoDeCaixa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_BOLETOS_FLUXO](context, idFluxoDeCaixa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("obterBoletosFluxo/" + idFluxoDeCaixa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_NFS_FLUXO](context, idFluxoDeCaixa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("obterNFsFluxo/" + idFluxoDeCaixa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_FLUXO_DE_CAIXA_PAGAMENTO](context, movimento) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("quitacaoTitulo", movimento).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_RELATORIOS_RECEBIMENTOS](context, filtros) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("relatorioRecebimentos", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_RELATORIOS_TRANSFERENCIAS](context, filtros) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("relatorioTransferencias", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    atualizarFluxoInclusaoAlteracaoBackup({ commit }, dados) {
        commit('updateFluxoInclusaoAlteracaoBackup', dados);
    }
};

const mutations = {
    [SET_FLUXOS_DE_CAIXA](state, fluxosDeCaixa) {
        state.fluxosDeCaixa = fluxosDeCaixa;
    },
    [SET_MENU_FLUXOS_DE_CAIXA](state, menu) {
        let indice = -1;

        state.fluxosDeCaixa.forEach(function(fluxoDeCaixa, index) {
            if (fluxoDeCaixa.ID_FLUXO_DE_CAIXA == menu.ID_FLUXO_DE_CAIXA) {
                indice = index;
            }
        });

        if (indice >= 0) {
            Vue.set(state.fluxosDeCaixa[indice], "menu", menu.MENU);
        }
    },
    [SET_SELECT_FLUXOS_DE_CAIXA](state, fluxoDeCaixaSelect) {
        let indice = -1;

        state.fluxosDeCaixa.forEach(function(fluxoDeCaixa, index) {
            if (
                fluxoDeCaixa.ID_FLUXO_DE_CAIXA == fluxoDeCaixaSelect.ID_FLUXO_DE_CAIXA
            ) {
                indice = index;
            }
        });

        if (indice >= 0) {
            if (state.fluxosDeCaixa[indice].selecionado) {
                Vue.set(state.fluxosDeCaixa[indice], "selecionado", false);
            } else {
                Vue.set(state.fluxosDeCaixa[indice], "selecionado", true);
            }
        }
    },
    [SET_FILTROS_FLUXOS_DE_CAIXA](state, fluxosDeCaixaUltimoFiltro) {
        state.fluxosDeCaixaUltimoFiltro = fluxosDeCaixaUltimoFiltro;
    },
    [SET_SUM_FLUXOS_DE_CAIXA](state, fluxosDeCaixa) {
        let arrayAux = [...state.fluxosDeCaixa, ...fluxosDeCaixa];
        Vue.set(state, "fluxosDeCaixa", arrayAux);
    },
    [SET_TOTAL_FLUXOS_DE_CAIXA](state, quantidadeTotal) {
        state.fluxosDeCaixaQuantidadeTotal = quantidadeTotal;
    },
    [SET_EMITENTES_PF_FLUXOS_DE_CAIXA](
        state,
        fluxosDeCaixaQuantidadeEmitentesPF
    ) {
        state.fluxosDeCaixaQuantidadeEmitentesPF = fluxosDeCaixaQuantidadeEmitentesPF;
    },
    [SET_EMITENTES_PJ_FLUXOS_DE_CAIXA](
        state,
        fluxosDeCaixaQuantidadeEmitentesPJ
    ) {
        state.fluxosDeCaixaQuantidadeEmitentesPJ = fluxosDeCaixaQuantidadeEmitentesPJ;
    },
    [SET_VALOR_FLUXOS_DE_CAIXA](state, fluxosDeCaixaQuantidadeValor) {
        state.fluxosDeCaixaQuantidadeValor = fluxosDeCaixaQuantidadeValor;
    },
    [SET_FLUXO_DE_CAIXA_BUSCA](state, fluxoDeCaixaBusca) {
        state.fluxoDeCaixaBusca = fluxoDeCaixaBusca;
    },
    [SET_FLUXOS_DE_CAIXA_TOTAL_PROJETOS](
        state,
        fluxosDeCaixaValoresTotaisProjetos
    ) {
        state.fluxosDeCaixaValoresTotaisProjetos = fluxosDeCaixaValoresTotaisProjetos;
    },
    [SET_FLUXOS_DE_CAIXA_TOTAL_PLANOS_FINANCEIROS](
        state,
        fluxosDeCaixaValoresTotaisPlanosFinanceiros
    ) {
        state.fluxosDeCaixaValoresTotaisPlanosFinanceiros = fluxosDeCaixaValoresTotaisPlanosFinanceiros;
    },
    [SET_FLUXOS_DE_CAIXA_TOTAL_CENTROS_DE_RESPONSABILIDADE](
        state,
        fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade
    ) {
        state.fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade = fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade;
    },
    [SET_FLUXOS_DE_CAIXA_TOTAL_PORTADORES](
        state,
        fluxosDeCaixaValoresTotaisPortadores
    ) {
        state.fluxosDeCaixaValoresTotaisPortadores = fluxosDeCaixaValoresTotaisPortadores;
    },
    updateFluxoInclusaoAlteracaoBackup(state, dados) {
        state.fluxoInclusaoAlteracaoBackup = dados;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};